import { formatDistance } from 'date-fns';
import qs from 'qs';
import React from 'react';
import { Button, Notice, NotificationList, NotificationListItem, Notification, Icon, Text, Grid, GridColumn } from 'telia-front-react';
import { pushGaData } from '../common';
import { notificationGa } from './store/NotificationStore';
const headerNotifications = (rootStore) => {
    const { notifications, markAsClicked, status, totalUnread, markAsRead } = rootStore.notificationStore;
    const { translate } = rootStore.translationsStore;
    const { locale, brand } = rootStore.environmentStore;
    const { customer, isDealer } = rootStore.ssoStore.authData || {};
    const notificationHeader = () => {
        var _a;
        if (isDealer) {
            return null;
        }
        return (React.createElement(Button, { text: translate('notifications.mark-as-read'), size: "small", link: true, type: "text-color", disabled: !((_a = notifications === null || notifications === void 0 ? void 0 : notifications.notificationTemplates) === null || _a === void 0 ? void 0 : _a.length), onClick: () => {
                markAsRead();
                pushGaData(notificationGa('Link - mark as read'));
            } }));
    };
    const notificationContent = () => {
        var _a;
        if (status === 'ERROR') {
            return React.createElement(Notice, { type: 'error' }, translate('notifications.error'));
        }
        if (!((_a = notifications === null || notifications === void 0 ? void 0 : notifications.notificationTemplates) === null || _a === void 0 ? void 0 : _a.length)) {
            return React.createElement(Notice, null, translate('notifications.empty'));
        }
        const sortNotificationsByDates = (notificationTemplates) => {
            const sortedNotifications = [];
            notificationTemplates.map((nt) => {
                sortedNotifications.push(...nt.customerNotifications);
            });
            return sortedNotifications.sort((a, b) => new Date(b.receivedTime).getTime() - new Date(a.receivedTime).getTime());
        };
        const getTemplateByName = (notification) => {
            return notifications.notificationTemplates.find((nt) => nt.type === notification.notificationTemplateName);
        };
        return (React.createElement(NotificationList, { key: 'customer-notifications' }, sortNotificationsByDates(notifications.notificationTemplates).map((cn) => {
            var _a, _b, _c;
            const notificationTemplate = getTemplateByName(cn);
            const isLink = ((_a = notificationTemplate.cta) === null || _a === void 0 ? void 0 : _a.buttonType) === 'link';
            return (React.createElement(NotificationListItem, { key: cn.customerNotificationId + notificationTemplate.id },
                React.createElement(Notification, { key: cn.customerNotificationId, id: `${cn.customerNotificationId}`, time: { isoTime: cn.receivedTime, formattedTime: formatDate(cn.receivedTime) }, type: notificationTemplate.level, isSeen: cn.read, tag: ((_b = notificationTemplate.category) === null || _b === void 0 ? void 0 : _b.labelKey) ? { text: translate((_c = notificationTemplate.category) === null || _c === void 0 ? void 0 : _c.labelKey) } : null, button: notificationTemplate.cta
                        ? {
                            text: translate(notificationTemplate.cta.labelKey),
                            type: notificationTemplate.cta.buttonType,
                            size: isLink ? undefined : 'small',
                            iconRight: '#arrow-right',
                            link: isLink,
                            url: cn.ctaUrl || notificationTemplate.cta.url + qs.stringify(cn.ctaParameters, { addQueryPrefix: true }),
                            onClick: () => {
                                if (!isDealer) {
                                    !cn.clicked && markAsClicked(cn.customerNotificationId);
                                    !cn.read && markAsRead([cn.customerNotificationId]);
                                    pushGaData(notificationGa(`Link - ${notificationTemplate.type}`));
                                }
                            }
                        }
                        : null }, getContent(notificationTemplate, cn))));
        })));
    };
    const tagProps = () => {
        if (!totalUnread) {
            return null;
        }
        return {
            text: `${totalUnread}`,
            purpose: 'information'
        };
    };
    const formatDate = (notificationDate) => {
        return formatDistance(new Date(notificationDate), new Date(), { locale, addSuffix: true });
    };
    const getContent = (n, cn) => {
        const notificationLabel = React.createElement(Text, null, translate(n.labelKey, 'global', cn.labelParameters));
        return n.icon ? (React.createElement(Grid, { noWrap: true, align: ['center-xs', 'middle-xs'], gutter: "small", className: "text-left" },
            React.createElement(GridColumn, { width: ['min'] },
                React.createElement(Icon, { modifiers: `#${n.icon}`, align: "middle", size: "xs" })),
            React.createElement(GridColumn, { width: ['max'] }, notificationLabel))) : (notificationLabel);
    };
    if (!customer || brand !== 'telia') {
        return null;
    }
    return {
        id: 'notifications',
        icon: '#alarm',
        url: '#',
        location: {
            xs: 'bottom',
            lg: 'top'
        },
        label: translate('notifications.label'),
        badge: tagProps(),
        dropdownSize: 'small',
        dropdownPadding: 'xsmall',
        dropdownHeader: notificationHeader(),
        dropdownContent: notificationContent(),
        showOverlay: false
    };
};
export default headerNotifications;
//# sourceMappingURL=HeaderNotifications.js.map